import { notifyAnalytics } from '@/api/analytics/notifyAnalytics'
import { ORAKLE_VEHICLE_STATUS_ENDPOINT } from '@/api/clients/orakle-client'
import { keycloak } from '@/main'
import type { Orakle_VehicleListReturn, Orakle_VehicleReturn } from '@/types/orakle_types'

export async function fetchAllVehicleStatuses() {
  try {
    const token = keycloak.token

    const response = await fetch(ORAKLE_VEHICLE_STATUS_ENDPOINT, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }
    const result = await response.text()
    return JSON.parse(result) as Orakle_VehicleListReturn
  } catch (error) {
    if (error instanceof SyntaxError) {
      // If JSON parsing fails, rethrow the error
      throw error
    } else {
      if (import.meta.env.MODE === 'development') {
        if (import.meta.env.VITE_VERBOSE_MODE === 'true')
          console.error('Fetching orakle vehicle status data failed.', error)
      } else notifyAnalytics({ type: 'log_error', data: error })
      return undefined
    }
  }
}

export async function fetchIndividualVehicleStatus(vehicle_directus_id: number): Promise<Orakle_VehicleReturn | "vehicle_not_found" | undefined> {
  try {
    const token = keycloak.token

    const response = await fetch(ORAKLE_VEHICLE_STATUS_ENDPOINT + `/${vehicle_directus_id}`, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    if (!response.ok) {      
      throw new Error(`HTTP error! status: ${response.status}`, { cause: await response.text()})
    }
    const result = await response.text()
    return JSON.parse(result) as Orakle_VehicleReturn 
  } catch (error) {
    if (error instanceof SyntaxError) {      
      // If JSON parsing fails, rethrow the error
      throw error
    } else {
      if (import.meta.env.MODE === 'development') {
        if (import.meta.env.VITE_VERBOSE_MODE === 'true')
          console.error('Fetching orakle vehicle status data failed.', error)
      } else notifyAnalytics({ type: 'log_error', data: error })
      if (error instanceof Error && (error.message.includes('404'))) {
        // specific handling for 404 errors
        return "vehicle_not_found"
      }
      return undefined
    }
  }
}

